import React, { useState, useCallback } from 'react'
import { kebabCase } from 'lodash'
import { Row, Col, ListGroup, Button, ButtonGroup } from 'react-bootstrap'
import FromToRange from './FromToRange'
import moment from 'moment'
import { DATE_DATA_FORMAT } from 'utils/constants'
import { List, ActionRangeButton, FromToColumn } from './DateRangePicker.style'

const defaultRanges = [
  {
    label: 'Today',
    days: 0,
  },
  {
    label: 'Last 7 days',
    days: 7,
  },
  {
    label: 'Last 30 days',
    days: 30,
  },
]

const DateRange = ({
  value,
  onChange,
  onCancel,
  showDefaultValues,
  isMulti = false,
}) => {
  const [customRanges, setCustomRanges] = useState(value || [['', '']])

  const handleDateChange = useCallback(
    (date, index) => {
      const newDates = [...customRanges]
      newDates[index] = date
      setCustomRanges(newDates)
    },
    [customRanges, setCustomRanges]
  )

  const isRangeEmpty = (range) => {
    let isEmpty = true
    range.forEach((r) => {
      isEmpty = isEmpty ? !r.some((d) => d) : false
    })
    return isEmpty
  }

  const renderCustomRange = () =>
    customRanges.length === 1 ? (
      <ActionRangeButton
        variant="link"
        onClick={() => setCustomRanges([...customRanges, ['', '']])}
      >
        Add another date Range
      </ActionRangeButton>
    ) : (
      <ActionRangeButton
        variant="link"
        onClick={() => setCustomRanges([customRanges[0]])}
      >
        Remove range
      </ActionRangeButton>
    )

  return (
    <>
      <Row>
        {showDefaultValues && (
          <Col md={6}>
            <List variant="flush">
              {defaultRanges.map(({ label, days }) => (
                <ListGroup.Item
                  action
                  key={kebabCase(label)}
                  onClick={() =>
                    handleDateChange(
                      [
                        moment()
                          .subtract(days, 'days')
                          .format(DATE_DATA_FORMAT),
                        moment().format(DATE_DATA_FORMAT),
                      ],
                      customRanges.length - 1
                    )
                  }
                >
                  {label}
                </ListGroup.Item>
              ))}
            </List>
          </Col>
        )}
        <FromToColumn>
          {customRanges.map((range, index) => (
            <FromToRange
              key={`range-${index}`}
              onChange={(date) => handleDateChange(date, index)}
              {...{ range }}
            />
          ))}
          {isMulti && renderCustomRange()}
        </FromToColumn>
      </Row>
      <Row>
        <Col style={{ textAlign: 'right' }}>
          <ButtonGroup aria-label="Basic example">
            <Button variant="link" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant="link"
              disabled={isRangeEmpty(customRanges)}
              onClick={() => onChange(customRanges)}
            >
              Apply
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </>
  )
}

export default DateRange
